/**
 * Returns the full path to the settings page of a Advanced-Settings of a specific installation
 */
export const getAdvancedSettingsDetailsRoute = (installationId = ':installationId', storageId?: string | null): string => {
  if (storageId) {
    return `/installation/${installationId}/${storageId}/properties/advanced-settings`
  }
  return `/installation/${installationId}/properties/advanced-settings`
}

/**
 * Returns the full path to the settings page of a specific installation
 */
export const getPropertiesSettingsDetailsRoute = (installationId = ':installationId', storageId?: string | null): string => {
  if (storageId) {
    return `/installation/${installationId}/${storageId}/properties`
  }
  return `/installation/${installationId}/properties`
}
